import {
  useAddressValidationValue,
  useCartCheckout,
  useCartCustomFields,
  useCartShippingAddress,
  useCartShippingMethodId
} from '@ecomm/data-cart'
import { getStringCustomField } from '@ecomm/data-cart/utils/getStringCustomField'
import { useLocale } from '@ecomm/data-hooks'
import { logError } from '@ecomm/error-handling'
import { useTrackingConfirmAddressShippingModalValidation } from '@ecomm/tracking'
import * as O from 'fp-ts/Option'
import { navigate } from 'gatsby'
import { useCallback } from 'react'

import {
  combineCartAndSuggestedAddress,
  getFirstSuggestedAddress
} from '../SubmitButton/addressValidationHelpers'

export const useModalSubmit = (
  redirectUrl: string,
  sameBillingAddress: boolean
) => {
  const cartCheckout = useCartCheckout()
  const shippingAddress = useCartShippingAddress()
  const shippingMethodId = useCartShippingMethodId()
  const addressValidation = useAddressValidationValue()
  const locale = useLocale()
  const customFields = useCartCustomFields()
  const leadSource = getStringCustomField(customFields, 'leadSource')
  const leadOther = getStringCustomField(customFields, 'leadOther')
  const trackConfirmAddress = useTrackingConfirmAddressShippingModalValidation()

  const handleError = useCallback((err: Error) => {
    logError(
      Error(`something went wrong updating user address: ${err.message}`)
    )
  }, [])

  const handleSuccess = useCallback(() => {
    navigate(redirectUrl)
  }, [redirectUrl])

  const onSubmit = useCallback(() => {
    trackConfirmAddress('Confirm verified address')

    cartCheckout(
      {
        leadOther: O.toUndefined(leadOther),
        leadSource: O.toUndefined(leadSource),
        sameBillingAddress,
        shippingAddress: combineCartAndSuggestedAddress(
          locale,
          shippingAddress,
          getFirstSuggestedAddress(addressValidation)
        ),
        shippingMethod: shippingMethodId || '',
        shouldValidate: false
      },
      handleError,
      handleSuccess
    )
  }, [
    cartCheckout,
    handleError,
    handleSuccess,
    shippingAddress,
    locale,
    shippingMethodId,
    sameBillingAddress,
    addressValidation,
    leadSource,
    leadOther
  ])

  return onSubmit
}
